import React, { Component } from "react";
import Dropzone from "react-dropzone";
import helpers from "../../helpers";
import moment from "moment";
import "moment/locale/he";
moment.locale("he");

export default class Map extends Component {
  constructor(props) {
    super(props);

    this.state = {
      app: props.app,
      main: props.main,
      files: [],
      loader: true,
      uploading: false,
      converting: false,
      uploadProgress: 0,
    };

    this.fileRef = props.file.current;
  }

  onFile = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    const content_type = "binary/octet-stream";
    if (file) {
      this.setState({ loader: true });
      const file_extension = file.name.split(".").pop().toLowerCase();
      const response = await helpers.serviceRequest("getPreSignedUrl", {
        file_extension,
        content_type,
      });
      const presigned_url = response.presigned_url;
      const path = helpers.getPathFromUrl(presigned_url);
      try {
        this.setState({ uploading: true, uploadProgress: 0 });
        await helpers.putObject(presigned_url, file, (percent) => {
          this.setState({ uploadProgress: percent });
        });
        this.setState({ uploading: false, converting: true });
        const pdfKey = await helpers.serviceRequest("print2pdf", {
          file: path,
        });
        this.setState({ converting: false });
        await helpers.addFileToUser({
          userRef: this.state.app.state.userRef,
          file: pdfKey,
        });
      } catch (e) {
        console.log(e);
      }
      this.setState({ loader: false });
    }
  };

  syncFiles = async () => {
    const clientFiles = this.state.app.state.client.files;
    if (clientFiles) {
      const clientFilesIds = clientFiles.map((clientFile) => clientFile.id);
      if (
        JSON.stringify(clientFilesIds) !=
        JSON.stringify(this.state.clientFilesIds)
      ) {
        this.setState({ clientFilesIds });
        let files = await helpers.getFiles(clientFiles);
        files.sort((a, b) => (a.timestamp < b.timestamp ? 1 : -1));
        this.setState({ files });
        this.setState({ loader: false });
      } else if (this.state.loader && clientFiles.length === 0) {
        console.log("no client files");
        this.setState({ loader: false });
      }
    } else {
      const { loader } = this.state;
      if (loader) this.setState({ loader: false });
    }
  };

  setPdf = (fileId) => {
    console.log(fileId);
    this.props.file.current.setPdf(fileId);
  };

  componentDidMount() {
    setTimeout(() => {
      this.syncFiles();
    }, 100);
  }

  componentDidUpdate() {
    this.syncFiles();
  }

  render() {
    const { loader, uploading, uploadProgress, converting } = this.state;
    const gallery = [];
    for (const file of this.state.files) {
      gallery.push(
        <div
          key={file.id}
          data-menu="menu-file"
          onClick={() => this.setPdf(file.id)}
          className="item"
        >
          <img src={file.thumbnail} />
          <span>{moment(file.timestamp).fromNow()}</span>
        </div>
      );
    }

    const showInstruction = !loader && !uploading && !converting && gallery.length === 0;

    return (
      <div className="map-page" style={{ height: "100%", width: "100%" }}>
        {showInstruction && (
          <div className="map-page-background">
            <p className="map-page-background-text">
              Go to the nearby printer and scan the QR code to start
            </p>
          </div>
        )}
        <Dropzone
          accept="image/*,application/*,text/*"
          multiple={false}
          fullscreen={false}
          onDrop={this.onFile}
        >
          {({ getRootProps, getInputProps }) => (
            <div className="dropzone" {...getRootProps()}>
              <input {...getInputProps()} />
              <i
                className="fad fa-file-import"
                style={{ paddingRight: 5 + "px" }}
              />{" "}
              Drop new files to print here or click to upload
            </div>
          )}
        </Dropzone>

        <div className="book-menu touchmove">
          {loader && !uploading && !converting && (
            <div className="loader">
              <i className="fal fa-circle-notch fa-spin"></i> Loading...
            </div>
          )}
          {uploading && (
            <div className="loader">
              <i className="fal fa-circle-notch fa-spin"></i> Uploading{" "}
              {uploadProgress}%
            </div>
          )}
          {converting && (
            <div className="loader">
              <i className="fal fa-circle-notch fa-spin"></i> Preparing your
              file...
            </div>
          )}
          {!loader && gallery.length === 0 && (
            <div className="gallery touchmove map-page-empty">
              <span className="missing-files">You don't have any files yet...</span>
            </div>
          )}
          {!loader && gallery.length > 0 && (
            <div className="gallery touchmove">{gallery}</div>
          )}
        </div>

        <div className="scan-wrapper">
          <label
            href="#"
            onClick={() => this.state.main.change("scan")}
            id="scan"
            className="button button-round-huge shadow-large"
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                width: 100 + "%",
                pointerEvents: "none",
              }}
            >
              <div
                style={{
                  height: 0 + "px",
                  marginTop: 28 + "px",
                  marginBottom: -25 + "px",
                  fontSize: 15 + "px",
                  letterSpacing: 3 + "px",
                  marginLeft: 2 + "px",
                }}
              >
                Scan
              </div>
              <div>
                <span className="fad fa-qrcode" style={{ zoom: 2.5 }}></span>
              </div>
            </div>
          </label>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/map.js